import { Link } from "react-router-dom";
import { platforms } from "@/mocks/platforms";

const platformImages: Record<string, string> = {
  "platform-hipobuy-01": "https://readdy.ai/api/search-image?query=Premium%20sneaker%20collection%20displayed%20on%20floating%20marble%20pedestals%20in%20warm%20ambient%20lighting%2C%20multiple%20designer%20athletic%20shoes%20arranged%20in%20artistic%20composition%2C%20luxury%20retail%20product%20photography%20with%20soft%20bokeh%20background%2C%20neutral%20tones%20with%20terracotta%20accent%20lighting%2C%20ultra-sharp%20detail&width=600&height=360&seq=platform-hipobuy-01-v2&orientation=landscape",
  "platform-kakobuy-01": "https://readdy.ai/api/search-image?query=Urban%20streetwear%20hoodie%20collection%20on%20brushed%20concrete%20wall%20with%20dramatic%20side%20lighting%2C%20premium%20cotton%20pullovers%20in%20earth%20tones%20hanging%20from%20industrial%20hooks%2C%20fashion%20editorial%20photography%20with%20deep%20shadows%2C%20raw%20urban%20aesthetic%2C%20sharp%20fabric%20texture%20detail&width=600&height=360&seq=platform-kakobuy-01-v2&orientation=landscape",
  "platform-cssbuy-01": "https://readdy.ai/api/search-image?query=Luxury%20leather%20accessories%20arranged%20on%20dark%20walnut%20desk%20with%20warm%20golden%20hour%20window%20light%2C%20designer%20belt%2C%20aviator%20sunglasses%2C%20minimalist%20wallet%20and%20premium%20watch%2C%20rich%20warm%20brown%20tones%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20magazine%20quality&width=600&height=360&seq=platform-cssbuy-01-v2&orientation=landscape",
  "platform-superbuy-01": "https://readdy.ai/api/search-image?query=High-performance%20sportswear%20flat%20lay%20on%20gym%20bench%20with%20dynamic%20rim%20lighting%2C%20athletic%20jerseys%20and%20compression%20joggers%20in%20geometric%20arrangement%2C%20moisture-wicking%20fabric%20texture%20visible%2C%20energetic%20warm%20color%20palette%20with%20orange%20and%20white%20accents%2C%20commercial%20product%20styling&width=600&height=360&seq=platform-superbuy-01-v2&orientation=landscape",
  "platform-oopbuy-01": "https://readdy.ai/api/search-image?query=Curated%20eclectic%20product%20discovery%20scene%20with%20vintage%20objects%2C%20artisan%20accessories%20and%20unique%20lifestyle%20items%20scattered%20on%20aged%20reclaimed%20wood%20table%2C%20warm%20nostalgic%20golden%20lighting%2C%20creative%20editorial%20flat%20lay%20with%20diverse%20textures%2C%20bokeh%20background&width=600&height=360&seq=platform-oopbuy-01-v2&orientation=landscape",
};

export default function PlatformCards() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
            Platform Ecosystem
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Explore <span className="text-primary-500">Spreadsheet Platforms</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Compare different spreadsheet resources to find the best fit for your shopping needs
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {platforms.map((platform) => (
            <div
              key={platform.slug}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={platformImages[platform.imageSeq]}
                  alt={`${platform.name} platform`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-semibold text-foreground-800">{platform.rating}</span>
                </div>
              </div>

              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{platform.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                  {platform.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-5">
                  {platform.features.slice(0, 3).map((f) => (
                    <span key={f} className="px-2.5 py-1 rounded-full text-xs bg-secondary-50 text-secondary-700 border border-secondary-200">
                      {f}
                    </span>
                  ))}
                </div>

                <Link
                  to={`/${platform.slug}`}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}